import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CounterComponent } from './counter/counter.component';
import { FormsModule } from '@angular/forms';
import { RoomComponent } from './room/room.component';

@NgModule({
  imports: [CommonModule, FormsModule],
  declarations: [CounterComponent, RoomComponent],
  exports: [CounterComponent, RoomComponent]
})
export class TravellerCountPickerModule {}
